import { AdvancedSearchConfig } from "../forms/advanced-search/advanced-search-fields-def";
import { ARTIST_LAST_NAME_SORT_LABEL } from "../forms/advanced-search/artist-sort-fields";
import { ColumnFormatted } from "./general";

export const authorsColumns: ColumnFormatted[] = [
  { type: "image", key: "vignette", visible: true },
  {
    type: "string",
    key: "artistesAuteursDescriptionNom",
    visible: true,
  },
  {
    type: "string",
    key: "artistesAuteursDescriptionPrenom",
    visible: true,
  },
  {
    type: "string",
    key: "artistesAuteursDescriptionEtatCivil",
    visible: true,
  },
  {
    type: "string",
    key: "artistesAuteursDescriptionDateNaissance",
    visible: true,
  },
  {
    type: "string",
    key: "artistesAuteursDescriptionVilleDeNaissance",
    visible: true,
  },
  {
    type: "string",
    key: "artistesAuteursDescriptionDateDeDeces",
  },
  {
    type: "string",
    key: "artistesAuteursDescriptionVilleDeDeces",
  },
  {
    type: "string",
    key: "artistesAuteursDescriptionResumeDates",
  },
  {
    type: "string",
    key: "artistesAuteursDescriptionNationalite",
  },
  {
    type: "string",
    key: "artistesAuteursDescriptionPaysDActivite",
  },
  {
    type: "string",
    key: "artistesAuteursDescriptionActivite",
  },
  {
    type: "string",
    key: "artistesAuteursDescriptionPeriodeDactivit",
  },
  {
    type: "richtext",
    key: "artistesAuteursDescriptionNotesBiographiques",
  },
  {
    type: "richtext",
    key: "artistesAuteursDescriptionNotesDeTravail",
  },
  {
    type: "string",
    key: "artistesAuteursAyantDroitsNom",
  },
  {
    type: "string",
    key: "artistesAuteursAyantDroitsContact",
  },
  {
    type: "string",
    key: "artistesAuteursAyantDroitsLienAvecLAuteur",
  },
  {
    type: "string",
    key: "artistesAuteursAyantDroitsOrganismeGerantLesDroits",
  },
  {
    type: "string",
    key: "artistesAuteursExpertCrNom",
  },
  {
    type: "string",
    key: "artistesAuteursExpertCrContact",
  },
  {
    type: "boolean",
    key: "artistesAuteursExpertCrCatalogueRaisonne",
  },
  {
    type: "string",
    key: "artistesAuteursExpertCrEtatDuCatalogueRaisonne",
  },
  {
    type: "richtext",
    key: "artistesAuteursExpertCrDescriptionDuCatalogueRaisonne",
  },
  {
    type: "string",
    key: "sources",
  },
];

export const authorsColumnsVisibility = authorsColumns.reduce(
  (acc, column) => ({
    ...acc,
    [column.key]: column.visible ?? true,
  }),
  {} as Record<string, boolean>,
);

export const authorsAdvancedSearchConfig: AdvancedSearchConfig = [
  {
    type: "group",
    label: "authorsDescription",
    fields: [
      {
        type: "string",
        key: "artistesAuteursDescriptionNom",
        sortLabel: ARTIST_LAST_NAME_SORT_LABEL,
      },
      { type: "string", key: "artistesAuteursDescriptionPrenom" },
      { type: "string", key: "artistesAuteursDescriptionEtatCivil" },
      { type: "string", key: "artistesAuteursDescriptionDateNaissance" },
      { type: "string", key: "artistesAuteursDescriptionVilleDeNaissance" },
      { type: "string", key: "artistesAuteursDescriptionDateDeDeces" },
      { type: "string", key: "artistesAuteursDescriptionVilleDeDeces" },
      { type: "string", key: "artistesAuteursDescriptionResumeDates" },
      { type: "string", key: "artistesAuteursDescriptionNationalite" },
      { type: "string", key: "artistesAuteursDescriptionPaysDActivite" },
      { type: "string", key: "artistesAuteursDescriptionActivite" },
      { type: "string", key: "artistesAuteursDescriptionPeriodeDactivit" },
      { type: "string", key: "artistesAuteursDescriptionNotesBiographiques" },
      { type: "string", key: "artistesAuteursDescriptionNotesDeTravail" },
      { type: "string", key: "artistesAuteursAyantDroitsNom" },
      { type: "string", key: "artistesAuteursAyantDroitsContact" },
      { type: "string", key: "artistesAuteursAyantDroitsLienAvecLAuteur" },
      {
        type: "string",
        key: "artistesAuteursAyantDroitsOrganismeGerantLesDroits",
      },
      { type: "string", key: "artistesAuteursExpertCrNom" },
      { type: "string", key: "artistesAuteursExpertCrContact" },
      { type: "boolean", key: "artistesAuteursExpertCrCatalogueRaisonne" },
      { type: "string", key: "artistesAuteursExpertCrEtatDuCatalogueRaisonne" },
      {
        type: "string",
        key: "artistesAuteursExpertCrDescriptionDuCatalogueRaisonne",
      },
    ],
  },
  {
    type: "group",
    label: "sources",
    fields: [{ type: "string", key: "sources" }],
  },
];
